<!--Reports grid-->
<div #divGrid class="col" [hidden]="!reports || !reports.length">
    <ag-grid-angular #agGridReports class="ag-theme-material">
    </ag-grid-angular>
</div>

<on-empty-list *ngIf="reports && !reports.length"></on-empty-list>
